/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareExclamationFill: {
  name: 'square-exclamation-fill';
  data: string;
} = {
  name: 'square-exclamation-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm9 7a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
